<div class="modal-header">
  <h3 class="modal-title">Kontakt auswählen</h3>
</div>
<div class="modal-body">
  <div class="whitelist contactlist">
    @if (data.data$ | async; as contactList) {
      <div class="whitelist-item click" (click)="select(null, contactList)">
        <h4>Kein Ansprechpartner</h4>
      </div>
      @for (contact of contactList; track contact) {
        <div class="whitelist-item click"
          (click)="select(contact, contactList)"
          [ngClass]="{selected: currentContact?.id === contact.id}">
          <h4>{{ contact.first_name }} {{ contact.last_name }}</h4>
          @if (contact.departments.length > 0) {
            <p>{{ contact.departments|JoinStringPipe }}</p>
          }
          @if (contact.position) {
            <p>{{ contact.position }}</p>
          }
          <div class="bottom">
            @if (contact.phone) {
              <p><i class="fa fa-phone"></i>{{ contact.phone }}</p>
            }
            @if (contact.mobile) {
              <p><i class="fa fa-mobile"></i>{{ contact.mobile }}</p>
            }
            @if (contact.mail) {
              <p><i class="fa fa-envelope"></i>{{ contact.mail }}</p>
            }
          </div>
        </div>
      }
    } @else {
      <ng-template [ngTemplateOutlet]="loadingOrError.template"></ng-template>
    }

    <loading-or-error
      #loadingOrError
      [loadingWrapper]="data"
      [errorMessage]="'Konnte \'Kontakte\' nicht laden'"
      [spinnerSize]="2"
      spinnerName="circle-o-notch">
    </loading-or-error>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-default pull-left" (click)="cancel()">Abbrechen</button>
</div>
